export const getInitials = (
  firstName: string | null | undefined,
  lastName: string | null | undefined
): string => {
  const first = firstName?.[0] || '';
  const last = lastName?.[0] || '';

  return (first + last).toUpperCase() || 'U';
};

export const getInitialsFromName = (
  name: string | null | undefined
): string => {
  if (!name) return '';

  const words = name.trim().split(/\s+/);
  const first = words[0]?.[0] || '';
  const second = words[1]?.[0] || '';

  return (first + second).toUpperCase();
};

export interface TruncatedDisplay {
  displayText: string;
  isTruncated: boolean;
}

export const getTruncatedDisplay = (
  value: string,
  maxLength: number
): TruncatedDisplay => {
  if (value.length <= maxLength) {
    return { displayText: value, isTruncated: false };
  }

  return {
    displayText: `${value.slice(0, maxLength)}...`,
    isTruncated: true,
  };
};

export interface UserNameSource {
  firstName?: unknown;
  lastName?: unknown;
  email?: unknown;
  id?: unknown;
}

export const UNKNOWN_USER_NAME = 'Unknown user';

const toText = (value: unknown): string =>
  typeof value === 'string' ? value.trim() : '';

const toIdText = (value: unknown): string =>
  typeof value === 'number' && Number.isFinite(value)
    ? String(value)
    : toText(value);

export const getUserDisplayName = ({
  firstName,
  lastName,
  email,
  id,
}: UserNameSource): string => {
  const fullName = [toText(firstName), toText(lastName)]
    .filter(Boolean)
    .join(' ');

  if (fullName) return fullName;

  const emailText = toText(email);

  if (emailText) return emailText;

  const idText = toIdText(id);

  return idText ? `User ${idText}` : UNKNOWN_USER_NAME;
};
